import { Button, Header, SpaceBetween, Table } from '@amzn/awsui-components-core';
import React from 'react';
import EmptyData from 'src/components/generic-components/EmptyData';
import { WelcomeContentDetailsEntity } from '../../AdminModels';
import { sanitizeHtml } from 'src/utilities/SanitizeHtml';

const APP_WELCOME_COLUMN_DEFINITIONS = [
  { id: 'displayText', header: 'Display Name', cell: (item: WelcomeContentDetailsEntity) => item.displayText, minWidth: 120 },
  { id: 'link', header: 'Link', cell: (item: WelcomeContentDetailsEntity) => item.link, minWidth: 125, maxWidth: 150 },
  { id: 'pointOfContact', header: 'Point Of Contact', cell: (item: WelcomeContentDetailsEntity) => item.pointOfContact || '', maxWidth: 120 },
  {
    id: 'description',
    header: 'Description',
    cell: (item: WelcomeContentDetailsEntity) => (
      <div className="description-cell">
        <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.description || '') }} />
      </div>
    ),
    width: 300,
    minWidth: 150
  }
];

interface WelcomeContentTableProps {
  tableDescriptionForErrors?: string | boolean | React.ReactNode;
  selectedWelcomeContentDetails: WelcomeContentDetailsEntity[];
  editWelcomeContent: () => void;
  deleteSelected: () => void;
  welcomeContentDetails: WelcomeContentDetailsEntity[];
  setSelectedWelcomeContentDetails: React.Dispatch<React.SetStateAction<WelcomeContentDetailsEntity[]>>;
}

export const WelcomeContentTable: React.FC<WelcomeContentTableProps> = ({
  tableDescriptionForErrors,
  selectedWelcomeContentDetails,
  editWelcomeContent,
  deleteSelected,
  welcomeContentDetails,
  setSelectedWelcomeContentDetails
}) => {
  return (
    <Table
      className="welcome-content-modal-table-container"
      variant="container"
      header={
        <Header
          description={tableDescriptionForErrors}
          actions={
            <SpaceBetween size="m" direction="horizontal">
              <Button formAction="none" disabled={selectedWelcomeContentDetails.length !== 1} onClick={editWelcomeContent}>
                Edit
              </Button>
              <Button formAction="none" disabled={selectedWelcomeContentDetails.length === 0} onClick={deleteSelected}>
                {`Delete (${selectedWelcomeContentDetails.length}) selected`}
              </Button>
            </SpaceBetween>
          }
        >
          Displayed Links
        </Header>
      }
      empty={<EmptyData />}
      columnDefinitions={APP_WELCOME_COLUMN_DEFINITIONS}
      items={welcomeContentDetails}
      selectionType="multi"
      selectedItems={selectedWelcomeContentDetails}
      onSelectionChange={({ detail }) => setSelectedWelcomeContentDetails(detail.selectedItems)}
    />
  );
};
